// extracted by mini-css-extract-plugin
export default {"btn":"CustomButton_btn__EBfRp","fill":"CustomButton_fill__AuHt3","outline":"CustomButton_outline__cNfAk"};